import axiosInstance from '../axiosInstance.js'

export default {
  getAllCountries() {
    return axiosInstance.get(
      `${import.meta.env.VITE_WELCOME_API_URL}/countries?pagination=false`
    )
  },

  enabledCountries() {
    return axiosInstance.get('/countries?page=1&pagination=false&enabled=true')
  },

  sendLead(payload) {
    return axiosInstance.post(
      `${import.meta.env.VITE_WELCOME_API_URL}/leads`,
      payload
    )
  },

  validateSlug(slug) {
    return axiosInstance.get(
      `${import.meta.env.VITE_WELCOME_API_URL}/stages/fqdn/validate/${slug}`
    )
  }
}
